/**
 * 患者眼写真の S3 キー命名規則。
 *
 * 1 つの diagnosisType ディレクトリ内で main / sub の写真を共存させるため、
 * sub 系のみキー末尾に `-sub` を付与する。
 *
 * - 右目・左目: `photo<N>` = まっすぐ前 / `photo<N>-sub` = あっかんべー
 * - 両目（アップニーク）: `photo<N>` = 点眼前 / `photo<N>-sub` = 点眼後
 *
 * `domain/index.ts` で `export * as PatientEyeImage` 経由で公開されるため、
 * 利用側からは `PatientEyeImage.SUB_SUFFIX` / `PatientEyeImage.isSubKey(key)` の
 * ように参照される。
 */
export const SUB_SUFFIX = "-sub";
/**
 * キーが「sub 系」（あっかんべー / 点眼後）かどうかを判定する。
 */
export const isSubKey = (key) => key.endsWith(SUB_SUFFIX);
/**
 * 患者眼写真の `Record<string, string>` 形式のエントリを
 * main（まっすぐ前 / 点眼前）と sub（あっかんべー / 点眼後）に振り分ける。
 *
 * clinic 側で点眼前後を別タブに表示する際などに使う。
 * 入力順は保持し、ソートは呼び出し側の責務とする。
 */
export const splitMainSubEntries = (entries) => {
    const main = [];
    const sub = [];
    for (const [key, value] of entries) {
        if (isSubKey(key))
            sub.push(value);
        else
            main.push(value);
    }
    return { main, sub };
};
